import * as React from 'react'
import { HTMLTable, Spinner, Intent, Tag } from '@blueprintjs/core'
import { fromNow } from '../../../utils/dateHelpers'
import { ucFirst } from '../../../utils'
import { TimeFrameDimensionOptionType } from '../types'

const STATUS_INTENT_MAP = {
  PROCESSING: Intent.PRIMARY,
  COMPLETE: Intent.SUCCESS,
  FAILED: Intent.DANGER
}

const reportHistoryTable = (
  showSpinner: boolean,
  reports: Array<any>,
  error: any,
  timeFrameDimensionOptions?: TimeFrameDimensionOptionType[]
) => {
  if (error) return <p>Unable to load reports</p>
  if (!reports || reports.length === 0) {
    if (showSpinner) return <Spinner />
    return <p>No recent reports</p>
  }

  const showTimeFrameDimension = timeFrameDimensionOptions?.length
  const timeFrameDimensionMap = showTimeFrameDimension
    ? timeFrameDimensionOptions.reduce((acc, next) => {
        acc[next.value] = next.label
        return acc
      }, {})
    : {}

  return (
    <HTMLTable striped style={{ width: '100%' }} className="bp3-html-table-condensed">
      <thead>
        <tr>
          <th>Created by</th>
          {showTimeFrameDimension && <th>Time Frame</th>}
          <th>Created</th>
          <th>Status</th>
          <th>Link</th>
        </tr>
      </thead>
      <tbody>
        {reports.map(report => (
          <tr key={report.id}>
            <td>{report.createdBy}</td>
            {showTimeFrameDimension && <td>{timeFrameDimensionMap[report.parameters?.timeFrameDimension]}</td>}
            <td>{fromNow(report.createdAt)}</td>
            <td>
              <Tag minimal intent={STATUS_INTENT_MAP[report.status]}>
                {ucFirst(report.status)}
              </Tag>
            </td>
            <td>
              {report.link && (
                <a target="_blank" rel="noopener noreferrer" href={report.link}>
                  Download
                </a>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </HTMLTable>
  )
}

export default reportHistoryTable
